forceRefresh